import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import "./Header.css";

const Header = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:600px)");
  const isTablet = useMediaQuery("(min-width:601px) and (max-width:852px)");

  // Use useLocation to determine the current path
  const location = useLocation();
  const isDocsPage = location.pathname.startsWith("/docs");

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleLaunchDapp = () => {
    window.location.href = "https://app.crowdlaunch.xyz";
  };

  const handleBuyLNCH = () => {
    window.open("https://dexscreener.com/bsc/0x0C89e1595950B42df8c9332BfC6407f17f0C8996", "_blank");
  };

  const logoUrl =
    "https://brokepiggytoken.xyz/wp-content/uploads/2025/05/crowdlaunch-logo-white.png";
  const dexscreenerLogoUrl = "https://mediaresource.sfo2.digitaloceanspaces.com/wp-content/uploads/2024/04/20232343/dex-screener-logo-png_seeklogo-527276.png";

  const drawerContent = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer}
      onKeyDown={toggleDrawer}
    >
      <List>
        <ListItem button component="a" href="/docs">
          <ListItemText primary="Docs" />
        </ListItem>
        <ListItem button component="a" href="/about">
          <ListItemText primary="About" />
        </ListItem>
        <ListItem button component="a" href="/blog">
          <ListItemText primary="Blog" />
        </ListItem>
      </List>
    </Box>
  );

  const menuLinkStyle = {
    color: "#FFFFFF",
    textTransform: "none",
    fontSize: "0.9rem",
    fontWeight: 500,
    backgroundColor: "transparent",
    "&:hover": {
      textDecoration: "underline",
      backgroundColor: "transparent",
    },
  };

  const launchButtonStyle = {
    backgroundColor: "#FFD700",
    color: "#1A1A1A",
    fontSize: "0.9rem",
    padding: "6px 12px",
    borderRadius: "4px",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#FFC107",
      boxShadow: "none",
    },
  };

  const buyLNCHButtonStyle = {
    backgroundColor: "#FFFFFF",
    color: "#1A1A1A",
    fontSize: "0.9rem",
    padding: "6px 12px",
    borderRadius: "4px",
    textTransform: "none",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "#FFC107",
      boxShadow: "none",
    },
    display: "flex",
    alignItems: "center",
  };

  return (
    <>
      <AppBar position="sticky" sx={{ backgroundColor: "#1C1C1E", boxShadow: "none" }}>
        <Box sx={{ backgroundColor: "#1C1C1E" }}>
          {isMobile ? (
            // MOBILE LAYOUT
            <Toolbar
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                paddingX: 1,
              }}
            >              
              <Box sx={{ display: "flex", alignItems: "center" }}>
                {/* Only render the logo if NOT on a docs page */}
                {!isDocsPage && (
                  <Box
                    component="img"
                    src={logoUrl}
                    alt="CrowdLaunch Logo"
                    className="logo"
                  />
                )}
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  marginBottom: "10px",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  width: "100%",
                  mt: 1,
                }}
              >
                
                <Button component="a" href="/docs" variant="text" sx={menuLinkStyle}>
                  Docs
                </Button>
                <Button component="a" href="/about" variant="text" sx={menuLinkStyle}>
                  Learn
                </Button>
                <Button component="a" href="/blog" variant="text" sx={menuLinkStyle}>
                  Blog
                </Button>
                <Button
                  onClick={handleBuyLNCH}
                  variant="contained"
                  sx={{
                    ...buyLNCHButtonStyle,
                    fontSize: { xs: "0.75rem", sm: "0.9rem" },
                    padding: { xs: "4px 8px", sm: "6px 12px" },
                  }}
                >
                  <Box
                    component="img"
                    src={dexscreenerLogoUrl}
                    alt="Dexscreener Logo"
                    sx={{ width: 20, height: 20, mr: 1 }}
                  />
                  Dexscreener
                </Button>
                <Button
                  onClick={handleLaunchDapp}
                  variant="contained"
                  sx={{
                    ...launchButtonStyle,
                    fontSize: { xs: "0.75rem", sm: "0.9rem" },
                    padding: { xs: "4px 8px", sm: "6px 12px" },
                  }}
                >
                  Launch Dapp
                </Button>
              </Box>
            </Toolbar>
          ) : isTablet ? (
            // TABLET LAYOUT
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", paddingX: 2 }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {!isDocsPage && (
                  <Box component="img" src={logoUrl} alt="CrowdLaunch Logo" className="logo" />
                )}
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                
                <Button onClick={handleLaunchDapp} variant="contained" sx={launchButtonStyle}>
                  Launch Dapp
                </Button>
                <Button onClick={handleBuyLNCH} variant="contained" sx={buyLNCHButtonStyle}>
                  <Box
                    component="img"
                    src={dexscreenerLogoUrl}
                    alt="Dexscreener Logo"
                    sx={{ width: 20, height: 20, mr: 1 }}
                  />
                  Dexscreener
                </Button>
                <Button component="a" href="/docs" variant="text" sx={menuLinkStyle}>
                  Docs
                </Button>
                <Button component="a" href="/about" variant="text" sx={menuLinkStyle}>
                  Learn
                </Button>
                <Button component="a" href="/blog" variant="text" sx={menuLinkStyle}>
                  Blog
                </Button>
              </Box>
            </Toolbar>
          ) : (
            // DESKTOP LAYOUT
            <Toolbar sx={{ paddingX: 2 }}>
              {/* On desktop, hide the header logo if on a docs page */}
              {!isDocsPage && (
                <Box component="img" src={logoUrl} alt="CrowdLaunch Logo" className="logo" />
              )}
              
              <Box sx={{ flexGrow: 1 }} />
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Button component="a" href="/docs" variant="text" sx={menuLinkStyle}>
                  Docs
                </Button>
                <Button component="a" href="/about" variant="text" sx={menuLinkStyle}>
                  Learn
                </Button>
                <Button component="a" href="/blog" variant="text" sx={menuLinkStyle}>
                  Blog
                </Button>
                <Button onClick={handleBuyLNCH} variant="contained" sx={buyLNCHButtonStyle}>
                  <Box
                    component="img"
                    src={dexscreenerLogoUrl}
                    alt="Dexscreener Logo"
                    sx={{ width: 20, height: 20, mr: 1 }}
                  />
                  Dexscreener
                </Button>
                <Button onClick={handleLaunchDapp} variant="contained" sx={launchButtonStyle}>
                  Launch Dapp
                </Button>
              </Box>
            </Toolbar>
          )}
        </Box>
      </AppBar>

      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer}>
        {drawerContent}
      </Drawer>
    </>
  );
};

export default Header;
